export const WebhookKey = {
  EMPLOYER_CHECK_CREATED: "check_created_webhook",
  TEST_EMPLOYER_CHECK_CREATED: "test_check_created_webhook",
  EMPLOYER_CHECK_PROCESSED: "check_processed_webhook",
  TEST_EMPLOYER_CHECK_PROCESSED: "test_check_processed_webhook",
  EMPLOYER_CHECK_PROCESSED_LEAN: "check_processed_lean_webhook",
  TEST_EMPLOYER_CHECK_PROCESSED_LEAN: "test_check_processed_lean_webhook",
  WORKER_CREATED: "worker_created_webhook",
  TEST_WORKER_CREATED: "test_worker_created_webhook",
  EMPLOYER_ONBOARDED: "employer_onboarding_webhook",
  TEST_EMPLOYER_ONBOARDED: "test_employer_onboarding_webhook",
  EMPLOYER_UPDATED: "employer_update_webhook",
  TEST_EMPLOYER_UPDATED: "test_employer_update_webhook",
  WORKER_ONBOARDED: "worker_onboarding_webhook",
  TEST_WORKER_ONBOARDED: "test_worker_onboarding_webhook",
  WORKER_I9_COMPLETED: "worker_i9_webhook",
  TEST_WORKER_I9_COMPLETED: "test_worker_i9_webhook",
  WORKER_EVERIFY_STATUS: "worker_everify_webhook",
  TEST_WORKER_EVERIFY_STATUS: "test_worker_everify_webhook",
  EMPLOYEE_UPDATED: "employee_webhook",
  TEST_EMPLOYEE_UPDATED: "test_employee_webhook",
  CONTRACTOR_UPDATED: "contractor_webhook",
  TEST_CONTRACTOR_UPDATED: "test_contractor_webhook",
  EMPLOYEE_CHECK_UPDATED: "employee_check_webhook",
  TEST_EMPLOYEE_CHECK_UPDATED: "test_employee_check_webhook",
  CONTRACTOR_PAYMENT_UPDATED: "contractor_payment_webhook",
  TEST_CONTRACTOR_PAYMENT_UPDATED: "test_contractor_payment_webhook",
  SHIFT_UPDATED: "worker_shift_webhook",
  TEST_SHIFT_UPDATED: "test_worker_shift_webhook",
  JOB_UPDATED: "job_webhook",
  TEST_JOB_UPDATED: "test_job_webhook",
  EMPLOYEE_REQUIREMENT_CREATED: "employee_requirement_created_webhook",
  EMPLOYEE_REQUIREMENT_UPDATED: "employee_requirement_updated_webhook",
  TEST_EMPLOYEE_REQUIREMENT_CREATED:
    "test_employee_requirement_created_webhook",
  TEST_EMPLOYEE_REQUIREMENT_UPDATED:
    "test_employee_requirement_updated_webhook",
  CUSTOMER_ACCOUNT_ONBOARDED: "customer_account_onboarding_webhook",
  TEST_CUSTOMER_ACCOUNT_ONBOARDED: "test_customer_account_onboarding_webhook",
  CUSTOMER_ACCOUNT_UPDATED: "customer_account_update_webhook",
  TEST_CUSTOMER_ACCOUNT_UPDATED: "test_customer_account_update_webhook",
  WORKER_PAYCARD_ONBOARDING: "worker_paycard_onboarding_webhook",
  TEST_WORKER_PAYCARD_ONBOARDING: "test_worker_paycard_onboarding_webhook",
  VERIFF_DECISION: "employee_veriff_decision_webhook",
  TEST_VERIFF_DECISION: "test_employee_veriff_decision_webhook",
  PERSONA_VERIFICATION: "persona_verification_webhook",
  TEST_PERSONA_VERIFICATION: "test_persona_verification_webhook",
  WALLET_TRANSACTION: "wallet_transaction_webhook",
  TEST_WALLET_TRANSACTION: "test_wallet_transaction_webhook",
  TRANSACTION_RETURNED: "transaction_returned_webhook",
  TEST_TRANSACTION_RETURNED: "test_transaction_returned_webhook",
  PAPERWORK_SUBMISSION: "paperwork_submission_webhook",
  TEST_PAPERWORK_SUBMISSION: "test_paperwork_submission_webhook",
} as const;
export type WebhookKey = (typeof WebhookKey)[keyof typeof WebhookKey];
